import React from "react";

interface ImgProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {
	src: string | null | undefined;
	alt: string | null | undefined;
}

/** Transparent 1x1 pixel PNG used as fallback when src is null/undefined */
const fallbackUrl =
	"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wIAAgMBAp8BMHcAAAAASUVORK5CYII=";

/**
 * A safe image component that handles null/undefined src and alt values gracefully.
 *
 * When src is null or undefined, renders a transparent 1x1 pixel fallback image.
 * When alt is null or undefined, defaults to empty string.
 */
export default function Img({ src, alt, ...rest }: ImgProps) {
	return <img src={src ?? fallbackUrl} alt={alt ?? ""} {...rest} />;
}
